/* Bella design rendszer – közös viselkedés a .bcb-ds oldalakhoz (assets/bcb-ds.css párja).
   - [data-rv], [data-rv-stagger]: beúszás görgetésre (IntersectionObserver). JS nélkül minden látszik.
   - [data-count]: számláló; a végén az eredeti szöveg áll vissza (pl. „3400+", „4,9").
   - [data-open]: élő nyitvatartás Europe/Budapest idő szerint.
       data-open='{"hours":{"0":[11,18],"3":[11,19],...},"closed":"2026-12-24,2026-12-25","lang":"hu"}'
       (0 = vasárnap; a hiányzó nap zárva). A szöveg a [data-open-txt] elembe kerül.
   - [data-mbar]: mobil sáv; a [data-mbar-after] elem után jelenik meg, a [data-mbar-hide] elemeknél eltűnik. */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root){
    if (root.__bcbDs) return; root.__bcbDs = true;

    /* ── Beúszás ── */
    var rvEls = root.querySelectorAll('[data-rv],[data-rv-stagger]');
    root.querySelectorAll('[data-rv-stagger]').forEach(function(p){
      Array.prototype.forEach.call(p.children, function(c, i){ c.style.setProperty('--i', i); });
    });
    if (!reduce && 'IntersectionObserver' in window && rvEls.length){
      root.classList.add('bcb-rv-on');
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting || e.boundingClientRect.top < 0){ e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      rvEls.forEach(function(el){ io.observe(el); });
      /* Biztosíték: ha valami miatt nem futna le, 4 mp után minden látszik. */
      setTimeout(function(){ rvEls.forEach(function(el){ var r = el.getBoundingClientRect(); if (r.top < innerHeight) el.classList.add('is-in'); }); }, 4000);
    }

    /* ── Számláló ── */
    var cEls = root.querySelectorAll('[data-count]');
    if (cEls.length && !reduce && 'IntersectionObserver' in window){
      var cio = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (!e.isIntersecting) return;
          cio.unobserve(e.target);
          var el = e.target, final = el.textContent, to = parseFloat(el.getAttribute('data-count')),
              dec = parseInt(el.getAttribute('data-dec') || '0', 10), sep = el.getAttribute('data-sep') || '.',
              suf = el.getAttribute('data-suf') || '', t0 = null, dur = 1400;
          function step(t){
            if (!t0) t0 = t;
            var p = Math.min(1, (t - t0) / dur), v = to * (1 - Math.pow(1 - p, 4));
            el.textContent = (dec ? v.toFixed(dec).replace('.', sep) : Math.round(v)) + suf;
            if (p < 1) requestAnimationFrame(step); else el.textContent = final;
          }
          requestAnimationFrame(step);
        });
      }, { threshold: 0.6 });
      cEls.forEach(function(el){ cio.observe(el); });
    }

    /* ── Élő nyitvatartás ── */
    root.querySelectorAll('[data-open]').forEach(function(el){
      var cfg; try { cfg = JSON.parse(el.getAttribute('data-open')); } catch(err){ return; }
      var txt = el.querySelector('[data-open-txt]') || el, s = openStatus(cfg);
      if (!s) return;
      txt.textContent = s.text;
      el.classList.add(s.open ? 'is-open' : 'is-closed');
      el.removeAttribute('hidden');
    });

    /* ── Háttér-dekor parallax ── */
    var par = root.querySelectorAll('[data-par]');
    if (par.length && !reduce && 'IntersectionObserver' in window){
      var pvis = new Set(), ptick = false;
      function pdraw(){
        ptick = false;
        pvis.forEach(function(el){
          var host = el.parentNode.getBoundingClientRect();
          var c = host.top + host.height / 2 - innerHeight / 2;
          el.style.translate = '0 ' + (c * parseFloat(el.getAttribute('data-par'))).toFixed(1) + 'px';
        });
      }
      function preq(){ if (!ptick){ ptick = true; requestAnimationFrame(pdraw); } }
      var pio = new IntersectionObserver(function(en){ en.forEach(function(e){ if (e.isIntersecting) pvis.add(e.target); else pvis.delete(e.target); }); preq(); }, { rootMargin: '200px 0px' });
      par.forEach(function(el){ pio.observe(el); });
      addEventListener('scroll', preq, { passive: true });
    }

    /* ── Görgetett képes történet ([data-fx]) ── */
    root.querySelectorAll('[data-fx]').forEach(function(fx){
      if (reduce) return;
      var imgs = fx.querySelectorAll('.fx-img'), steps = fx.querySelectorAll('.fx-step'),
          dots = fx.querySelectorAll('.fx-prog button'), bars = fx.querySelectorAll('.fx-bar i'), n = steps.length;
      if (!n) return;
      fx.style.setProperty('--n', n);
      fx.classList.add('fx-on');
      var cur = -1, queued = false;
      function draw(){
        queued = false;
        var r = fx.getBoundingClientRect(), span = r.height - innerHeight;
        var p = Math.min(1, Math.max(0, -r.top / (span || 1))), f = p * n, idx = Math.min(n - 1, Math.floor(f)), local = Math.min(1, f - idx);
        var e = Math.min(1, Math.max(0, 1 - r.top / innerHeight));
        fx.style.setProperty('--e', e.toFixed(3));
        if (idx !== cur){
          cur = idx;
          imgs.forEach(function(im, i){ im.classList.toggle('is-on', i === idx); });
          steps.forEach(function(st, i){ st.classList.toggle('is-on', i === idx); st.classList.toggle('is-past', i < idx); st.setAttribute('aria-hidden', i === idx ? 'false' : 'true'); });
          dots.forEach(function(d, i){ d.classList.toggle('is-on', i === idx); });
        }
        if (imgs[idx]) imgs[idx].style.setProperty('--z', (1.14 - 0.14 * local).toFixed(4));
        bars.forEach(function(b, i){ b.style.setProperty('--f', i < idx ? 1 : i === idx ? local.toFixed(3) : 0); });
      }
      function req(){ if (!queued){ queued = true; requestAnimationFrame(draw); } }
      addEventListener('scroll', req, { passive: true });
      addEventListener('resize', req);
      dots.forEach(function(d, i){
        d.addEventListener('click', function(){
          var r = fx.getBoundingClientRect(), span = r.height - innerHeight;
          scrollTo({ top: scrollY + r.top + span * ((i + 0.35) / n), behavior: 'smooth' });
        });
      });
      draw();
    });

    /* ── Mobil sáv ── */
    var bar = root.querySelector('[data-mbar]'), after = root.querySelector('[data-mbar-after]');
    if (bar && after && 'IntersectionObserver' in window){
      var pastHero = false, hideN = 0, hideSet = new Set();
      function sync(){
        var on = pastHero && hideSet.size === 0;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        bar.querySelectorAll('a,button').forEach(function(a){ a.tabIndex = on ? 0 : -1; });
        document.body.classList.toggle('bcb-mbar-on', on && innerWidth <= 760);
      }
      new IntersectionObserver(function(en){
        en.forEach(function(e){ pastHero = !e.isIntersecting && e.boundingClientRect.top < 0; });
        sync();
      }).observe(after);
      var hio = new IntersectionObserver(function(en){
        en.forEach(function(e){ if (e.isIntersecting) hideSet.add(e.target); else hideSet.delete(e.target); });
        sync();
      });
      root.querySelectorAll('[data-mbar-hide]').forEach(function(h){ hio.observe(h); });
      sync();
    }
  }

  /* Budapesti helyi idő: hét napja (0 = vasárnap), óra tört része és dátum (YYYY-MM-DD). */
  function bpNow(offsetDays){
    var d = new Date(Date.now() + (offsetDays || 0) * 864e5), parts = {};
    try {
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Budapest', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false, weekday: 'short' })
        .formatToParts(d).forEach(function(p){ parts[p.type] = p.value; });
    } catch(e){ return null; }
    var wd = { Sun:0, Mon:1, Tue:2, Wed:3, Thu:4, Fri:5, Sat:6 }[parts.weekday];
    return { wd: wd, h: (parseInt(parts.hour, 10) % 24) + parseInt(parts.minute, 10) / 60, date: parts.year + '-' + parts.month + '-' + parts.day };
  }
  var DAYS = {
    hu: ['vasárnap','hétfőn','kedden','szerdán','csütörtökön','pénteken','szombaton'],
    en: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
  };
  function hhmm(h){ var H = Math.floor(h), M = Math.round((h - H) * 60); return H + ':' + (M < 10 ? '0' : '') + M; }
  function openStatus(cfg){
    var lang = cfg.lang === 'en' ? 'en' : 'hu', hours = cfg.hours || {}, closed = (cfg.closed || '').split(/[\s,;]+/).filter(Boolean);
    var now = bpNow(0); if (!now || now.wd === undefined) return null;
    function slot(dayOffset){
      var n = bpNow(dayOffset); if (!n) return null;
      if (closed.indexOf(n.date) > -1) return null;
      return hours[n.wd] || null;
    }
    var today = slot(0);
    if (today && now.h >= today[0] && now.h < today[1]){
      return { open: true, text: lang === 'hu' ? 'Most nyitva · ' + hhmm(today[1]) + '-ig' : 'Open now · until ' + hhmm(today[1]) };
    }
    if (today && now.h < today[0]){
      return { open: false, text: lang === 'hu' ? 'Ma ' + hhmm(today[0]) + '-kor nyitunk' : 'Opens today at ' + hhmm(today[0]) };
    }
    for (var i = 1; i <= 7; i++){
      var s = slot(i);
      if (s){
        var n = bpNow(i);
        if (i === 1) return { open: false, text: lang === 'hu' ? 'Holnap ' + hhmm(s[0]) + '-kor nyitunk' : 'Opens tomorrow at ' + hhmm(s[0]) };
        return { open: false, text: lang === 'hu' ? 'Most zárva · ' + DAYS.hu[n.wd] + ' ' + hhmm(s[0]) + '-kor nyitunk' : 'Closed now · opens ' + DAYS.en[n.wd] + ' ' + hhmm(s[0]) };
      }
    }
    return null;
  }

  function boot(){ document.querySelectorAll('.bcb-ds').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
